<template>
  <v-chip
    v-if="element.id"
    @click:close="closeFunction(...closeFunctionParameters)"
    :close="close"
    close-icon="mdi-close"
    :color="elementColor"
    :class="`${!element.loading && ((showLogicalLanguage && !element.prolog) || (!showLogicalLanguage && !element.name)) ? 'rai-custom-chip__red-border' : ''}
      px-6 mr-1 my-1 black--text font-weight-bold`"
  >
    <span class="rai-custom-loader__button" v-show="element.loading">
      <v-icon dark>mdi-cached</v-icon>
    </span>
    <v-icon
      v-show="!element.loading"
      v-if="edit"
      @click="editFunction(...editFunctionParameters)"
      left
      small
    >
      mdi-pencil-outline
    </v-icon>
    <span
      v-show="!element.loading"
      class="rai-natural-language"
    >
      {{ !showLogicalLanguage ? element.name || $t('global.notranslation') : element.prolog || $t('global.notranslation') }}
    </span>
  </v-chip>
</template>

<script>
export default {
  name: 'ElementChip',

  props: {
    element: {
      type: Object,
      required: true,
    },
    close: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    closeFunctionParameters: {
      type: Array,
      required: false,
      default: () => {},
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    editFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    editFunctionParameters: {
      type: Array,
      required: false,
      default: () => {},
    },
  },

  computed: {
    showLogicalLanguage () {
      return this.$store.state.showLogicalLangage;
    },

    elementColor() {
      let color = 'secondary';
      if(this.element.type === 'belief') {
        color = 'teal lighten-2';
      }
      else if(this.element.type === 'hypothesis') {
        color = 'cyan lighten-1';
      }
      return color;
    }
  },
};
</script>